import workflowFormRouter from '../router/workflowFormRouter'
export default
    {
        path: "/workflow",
        component: () => import('../view/workflow/WorkflowFormMain.vue'),
        children: [
            workflowFormRouter
        ]

    }



// WEBPACK FOOTER //
// ./src/router/worflowRouter.js